module.exports = __webpack_public_path__ + "static/img/other-sex-icon.e947cba8.svg";